export type GuideSeason = "cool" | "warm"

export interface SeasonTheme {
  blade: string
  accent: string
  tintFrom: string
  tintTo: string
}

const COOL: SeasonTheme = {
  blade: "#0e7490",
  accent: "#0891b2",
  tintFrom: "#ecfeff",
  tintTo: "#f0fdfa",
}

const WARM: SeasonTheme = {
  blade: "#c2410c",
  accent: "#ea580c",
  tintFrom: "#fff7ed",
  tintTo: "#fffbeb",
}

export function getSeasonTheme(season: GuideSeason): SeasonTheme {
  return season === "cool" ? COOL : WARM
}
